import Vue from 'vue'
import VueI18n from "vue-i18n/dist/vue-i18n.esm.browser"

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    Vue: Vue,
    dsn: "https://820a1332383145d1a336ad73009f9d8d@o263715.ingest.sentry.io/5809846",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
});

import App from './App.vue'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import {library} from '@fortawesome/fontawesome-svg-core'
import {faCheck, faDownload, faSearch, faTimes} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
library.add(faCheck);
library.add(faSearch);
library.add(faTimes);
library.add(faDownload);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueI18n)

const country = window.location.host.replace(/.*\./, '')
const i18n = new VueI18n({
    locale: country === 'cz' ? 'cs' : country,
    fallbackLocale: 'cs',
    messages: require('./messages').default,
})

new Vue({
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
